import urlParse from 'url-parse';

export const getIssueKey = (url: string) => {
	const parsedUrl = urlParse(url);
	const parsedIssueKeyWithPossibleParams = parsedUrl.hash.split('/').pop();
	// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
	const [issueKey] = parsedIssueKeyWithPossibleParams.split('?');
	return issueKey;
};
